import { ABILITIES, BOSS_TYPES, COLORS, DIFFICULTY, ENEMY_TYPES, RUN_LENGTH_SEC, SCHEDULE, SPAWN, TIER_UNLOCK } from '../balance';
import { BASE_PASSIVE_KEYS } from '../passives';
import type { LevelDefinition } from './types';

/**
 * The shipping arena. It deliberately references the established balance data
 * while level consumers are introduced, so this extraction cannot rebalance it.
 */
export const BASE_LAB_LEVEL: LevelDefinition = {
  id: 'base_lab',
  displayName: 'Base Lab',
  entitlement: 'base',
  runLengthSec: RUN_LENGTH_SEC,
  musicTrack: 'baseLab',
  victoryBossKey: 'catalyst',
  schedule: SCHEDULE,
  tierUnlocks: TIER_UNLOCK,
  enemyTypes: ENEMY_TYPES,
  bossTypes: BOSS_TYPES,
  weaponKeys: ['acid', 'fire', 'frost', 'spark', 'poison', 'arcane', 'steam', 'caustic', 'napalm', 'shatter', 'storm', 'vitriol'],
  startingWeaponKey: 'acid',
  passiveKeys: BASE_PASSIVE_KEYS,
  abilities: ABILITIES,
  spawnTuning: {
    distancePx: SPAWN.distancePx,
    distanceJitterPx: SPAWN.distanceJitterPx,
    maxActive: SPAWN.maxActive,
    maxPerTick: SPAWN.maxPerTick,
    baseSpawnPerSec: DIFFICULTY.baseSpawnPerSec,
    maxSpawnPerSec: DIFFICULTY.maxSpawnPerSec,
    rampToMaxSec: DIFFICULTY.rampToMaxSec,
    hpScalePerMin: DIFFICULTY.hpScalePerMin,
    dmgScalePerMin: DIFFICULTY.dmgScalePerMin,
  },
  visualTheme: {
    backgroundColor: COLORS.bg,
    gridColor: COLORS.grid,
    groundTexture: 'stone',
    obstacleTexture: 'boulder',
    puddleTexturePrefix: 'puddle',
    foliage: 'grass',
    altarTexture: 'altar',
  },
};
